import { HelpCircle } from 'lucide-react'
import React, { useRef, useState } from 'react'
import { useClickOutside } from '@/hooks'
import './help-tooltip.css'

interface HelpTooltipProps {
	title: string
	ariaLabel: string
	children: React.ReactNode
}

export function HelpTooltip({ title, ariaLabel, children }: HelpTooltipProps) {
	const [isOpen, setIsOpen] = useState(false)
	const tooltipRef = useRef<HTMLDivElement>(null)

	useClickOutside(tooltipRef, () => setIsOpen(false), isOpen)

	return (
		<div className="help-tooltip" ref={tooltipRef}>
			<button
				type="button"
				onClick={() => setIsOpen(!isOpen)}
				className="help-tooltip-button"
				aria-label={ariaLabel}
			>
				<HelpCircle className="help-tooltip-icon" />
			</button>

			{isOpen && (
				<div className="help-tooltip-popover">
					<h4 className="help-tooltip-title">{title}</h4>
					<div className="help-tooltip-content">
						{children}
					</div>
				</div>
			)}
		</div>
	)
}
